import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="cms-booking-repeat"
export default class extends Controller {

  static targets = ['checkdate', 'checkdatediv', 'checkDateSubmit', 'input', 'days', 'endMethods', 'repeats', 'occurs']

  checkdate(){
    this.checkdateTarget.value = 'true';
  }

  checkDateSubmit(){
    this.checkDateSubmitTarget.click();
  }

  connect() {
  }

  select(event) {
    this.hideAll();
    let val = event.srcElement.value
    if((val == 'none') || (val == '')){
      return;
    } else {
      this.showCheckDate();
      this.showEndMethods();
      if(val == 'specified_days'){
        this.showDays();
      } else if(val == 'custom'){
        this.showRepeats();
        this.showDays();
      } else {
        return
      }
    }
  }

  hideAll(){
    this.hideCheckDateDiv();
    this.hideDays();
    this.hideEndMethods();
    this.hideRepeats();
  }

  hideCheckDateDiv(){
    this.checkdatedivTarget.classList.add('hidden');
  }

  hideDays(){
    this.daysTarget.classList.add('hidden');
  }

  hideEndMethods(){
    this.endMethodsTarget.classList.add('hidden');
  }

  hideRepeats(){
    this.repeatsTarget.classList.add('hidden');
  }

  showCheckDate(){
    this.checkdatedivTarget.classList.remove('hidden');
  }

  showDays(){
    this.daysTarget.classList.remove('hidden');
  }

  showEndMethods(){
    this.endMethodsTarget.classList.remove('hidden');
  }

  showRepeats(){
    this.repeatsTarget.classList.remove('hidden');
  }
}
